import { v4 as uuidv4 } from "uuid";
import actionType from "./_actions";

const _handleSave = (offlineFarms, payload) => {
    const { farmId, budgetId, snowfall } = payload;

    if (snowfall.id === undefined || snowfall.id === null) snowfall.id = uuidv4();

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    const snowfalls = (offlineBudget.budget.snowfalls || []).filter((item) => item.id !== snowfall.id);
                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            snowfalls: snowfalls.concat(snowfall),
                        },
                    };
                }),
            },
        };
    });
};

const _handleDelete = (offlineFarms, payload) => {
    const { farmId, budgetId, snowfallId } = payload;

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            snowfalls: offlineBudget.budget.snowfalls.filter((item) => item.id !== snowfallId),
                        },
                    };
                }),
            },
        };
    });
};

const reducer = (state = [], action) => {
    let offlineFarms = state;
    if (!Array.isArray(state)) {
        offlineFarms = Object.keys(state).map((item) => state[item]);
    }

    switch (action.type) {
        case actionType.SNOWFALL_SAVE:
            return _handleSave(offlineFarms, action.payload);

        case actionType.SNOWFALL_DELETE:
            return _handleDelete(offlineFarms, action.payload);

        default:
            return offlineFarms;
    }
};

export default reducer;
